module.exports = __webpack_public_path__ + "img/TUR-i-2-I.2a299205.png";